import { Form } from "antd";
import useDateWatch from "hooks/useDateWatch";
import TicketPoolListField from "views/TicketTemplates/TicketTemplateCreate/partials/TicketPoolListField";
import { EventType } from "@ticketingplatform/api/dist/__generated__/globalTypes";

import { TicketsProps } from "./types";

const Tickets: React.FC<TicketsProps> = ({ eventType }) => {
  const eventDate = useDateWatch(["input", "date"]);

  return (
    <Form.Item name={["input", "ticketPools"]} noStyle>
      <TicketPoolListField
        {...{ eventDate }}
        name={["input", "ticketPools"]}
        allowAddFromTicketTemplate={eventType === EventType.TICKETED}
        asSignUpOptions={eventType === EventType.NONTICKETED}
      />
    </Form.Item>
  );
};

export default Tickets;
